import React from 'react';

function About() {
	return (
		<section id="about">
			<h2>Blurb</h2>
			<p>I'm a Conversion Rate Optimisation specialist currently employed by N Brown. I utilise my expertise in web development, UI/UX design and behavioural psychology to optimise websites from a wide variety of sectors to improve their performance.</p>
		</section>
	);
}

export default About;
